<div class="p-5">
    @for (feed of feeds; track feed; let i = $index) {
        <div class="d-flex align-items-center gap-4">
            <div class="form-check">
                <input class="form-check-input"
                       type="checkbox"
                       [(ngModel)]="feed.checked"
                       [disabled]="isDisabled(feed.type)"
                       [id]="feed.type">
                <label class="form-check-label"
                       [for]="feed.type">
                    {{ feed.label }}
                </label>
            </div>
            @if (showShippingMethods(feed.type)) {
                <div class="d-flex align-items-center gap-4">
                    <ws-select [options]="outputTypes"
                                [isPrimitive]="true"
                                size="sm"
                                [(ngModel)]="selectedOutputType">
                    </ws-select>
                    <button
                        type="button"
                        class="ace-btn btn-primary btn-sm"
                        (click)="launchShippingMethodsModal()"
                        style="margin: 0;">
                        Shipping Methods
                    </button>
                </div>
            }
        </div>
    }

    <div class="mt-5">
        <button type="button"
                class="ace-btn btn-primary"
                (click)="download()"
                [disabled]="isDownloadDisabled">
            Download Selected Items
        </button>
    </div>
</div>
